import { render, staticRenderFns } from "./BulkCancelDaDialog.vue?vue&type=template&id=2b73dbdb"
import script from "./BulkCancelDaDialog.vue?vue&type=script&lang=js"
export * from "./BulkCancelDaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports